import React, {useContext, useState} from 'react';
import OrgPage from "../../../components/OrgPage";
import {SystemManager_API} from "../SystemManager.API";
import LinkCell from "../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import {observer} from "mobx-react";
import ModalsStore from "../../../components/Pages/Modals.store";
import IconCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/IconCell/IconCell";
import {useHttp} from "../../../hooks/http.hook";
import {AuthContext} from "../../../context/AuthContext";
import {generateRandomString} from "../../../utils/generateRandomString";
import {roleIdToString} from "../../../utils/utils";

const Roles = observer(() => {
    const {
        getAssistants,
        getAssistant,
        updateAssistant,
        deleteAssistant,
        addAssistant
    } = SystemManager_API.activities.assistants

    const {request} = useHttp()
    const {token} = useContext(AuthContext)
    const [refresh, setRefresh] = useState(false)

    const getAssistantRequest = async (assistantId) => {
        return await request(process.env.REACT_APP_BASE_URL + getAssistant(token.userId,assistantId).api, getAssistant().method, null, {Authorization: `Bearer ${token.token}`})
            .then(response => response.data.data)
            .then(response => {
                return {
                    ...response,
                    verificationCenter: response.name
                }
            })

    }

    const updateAssistantRequest = async (formData, assistantId) => {
        return await request(process.env.REACT_APP_BASE_URL + updateAssistant(token.userId,assistantId).api, updateAssistant().method, formData, {Authorization: `Bearer ${token.token}`})
    }

    const addAssistantRequest = async (formData, assistantId) => {
        return await request(process.env.REACT_APP_BASE_URL + addAssistant(token.userId,assistantId).api, addAssistant().method, formData, {Authorization: `Bearer ${token.token}`})
    }

    const deleteAssistantRequest = async (assistantId) => {
        return await request(process.env.REACT_APP_BASE_URL + deleteAssistant(token.userId,assistantId).api, deleteAssistant().method, null, {Authorization: `Bearer ${token.token}`})
    }


    return (
        <OrgPage
            url={`${process.env.REACT_APP_BASE_URL}` + getAssistants(token.userId).api}
            refresh={refresh}
            exportTemplateButtons={{export: false, registry: false}}
            filterBarButtons={{downloadTemplate: {show: false,}}}
            filterFieldsConf={{
                fio: true,
                verCenter: true
            }}
            addOrg={
                {
                    custom: {
                        text: 'Добавить сотрудника',
                        onClick: () => {
                            ModalsStore.showModal("AssistantsModal", {
                                    initialForm: {
                                        login: generateRandomString(8),
                                        password: generateRandomString(10)
                                    },
                                    roleSelectOptions: [
                                        {label: 'Лаборант/Кабинет', name: 'role', value: 9},
                                        {label: 'Лаборант/Машина', name: 'role', value: 10},
                                        {label: 'Доктор', name: 'role', value: '6'},

                                    ]
                                },
                                {
                                    submit(formData) {
                                        return addAssistantRequest(formData)
                                            .then(res => res.status === 201 && 'success')
                                    },
                                    closeHandler() {
                                        setRefresh(!refresh)
                                    }
                                }
                            )
                        }
                    }
                }}
            breadCrumbsItems={[
                {title: 'Активность'},
                {title: 'Лаборанты', actual: true},
            ]}
            firstRow={[
                {title: 'Удостоверяющий центр'},
                {title: 'ФИО'},
                {title: 'Роль'},
                {title: 'Удаление'},
            ]}
            haveToShow={[
                {
                    type: 'wrapperCell',
                    typeData: {
                        cell: props => <LinkCell linkTitle={props.all?.name}
                                                 editClick={async _ => ModalsStore.showModal("AssistantsModal",
                                                     {
                                                         editingMode: true,
                                                         initialForm: await getAssistantRequest(props.all.id),
                                                         roleSelectOptions: [
                                                             {label: 'Лаборант/Кабинет', name: 'role', value: 9},
                                                             {label: 'Лаборант/Машина', name: 'role', value: 10},
                                                             //{label: 'Доктор', name: 'role', value: '6'},
                                                         ]
                                                     },
                                                     {
                                                         closeHandler: () => {
                                                             setRefresh(!refresh)
                                                         },
                                                         submit(formData) {
                                                             return updateAssistantRequest(formData, props.all.id)
                                                                 .then(res => res.status === 200 && 'success')
                                                         }
                                                     }
                                                 )}/>
                    }
                },

                {type: 'wrapperCell', typeData: {cell: props => <LinkCell linkTitle={props.all.fio}/>}},
                {type: 'wrapperCell', typeData: {cell: props => <LinkCell linkTitle={roleIdToString(props.all.role + 0)}/>}},
                {
                    type: 'wrapperCell', typeData: {
                        cell: props => <IconCell iconName={'trash'}
                                                 onClick={_ => {
                                                     deleteAssistantRequest(props.all.id).then(res => setRefresh(!refresh))
                                                 }}/>
                    }
                }
            ]}
        />

    );
})

export default Roles;